import { useEffect, useState, useRef } from 'react'
import { useGLTF, Environment } from '@react-three/drei'
import { SceneChild, JustPickedApplesMap } from '../types/portfolio_types'
import {
  RigidBody,
  RigidBodyTypeString,
  RapierRigidBody,
  RigidBodyAutoCollider,
  Boolean3Tuple,
  CuboidCollider,
  CollisionPayload,
} from '@react-three/rapier'
import { getAppleData } from '../store/localstorageData'
import * as THREE from 'three'
import { interactable_mushroom_room_objects } from '../interactable_data/mushroom_house_data'
import {
  floorLoadedAtom,
  availableInteractableObjectAtom,
  pickedApplesAtom,
  currentInteractionAtom,
} from '../store/store'
import { useAtom } from 'jotai'
import AppleSparkles from './AppleSparkles'
import { deepDispose } from '../helpers/deepDispose'

const objects_with_custom_components = ['apple']

// For some reason, this bg doesn't load (throws an error) on m1 Mac's Firefox.
// So, the easier thing is to define it as a base64 image here. It's only 2kb.
const ROOM_BG =
  'data:image/png;base64,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'

const MushroomHouseInterior = () => {
  const model = useGLTF('/models/portfolio_forest/mushroom_house_interior2_draco.glb')
  const [sceneChildren, setSceneChildren] = useState<SceneChild[]>([])
  const [floorLoaded, setFloorLoaded] = useAtom(floorLoadedAtom)
  const [, setInteractableObject] = useAtom(availableInteractableObjectAtom)
  const [currentInteractionObj] = useAtom(currentInteractionAtom)
  const [pickedApples, setPickedApples] = useAtom(pickedApplesAtom)
  const [justPickedApples, setJustPickedApples] = useState<JustPickedApplesMap>({})
  const floor_physics_body = useRef<RapierRigidBody | null>(null)
  const last_bed_apple_position_ref = useRef<THREE.Vector3 | null>(null)
  const bed_apple_ref = useRef<RapierRigidBody | null>(null)
  const pulled_apple = useRef(false)

  // const pointLightRef = useRef<THREE.PointLight>(null)
  // useHelper(pointLightRef, THREE.PointLightHelper, 1, 'red')

  useEffect(() => {
    if (floor_physics_body.current && !floorLoaded) {
      setFloorLoaded(true)
    }
  })

  useEffect(() => {
    const processedSceneChildren = model.scene.children.map((child) => {
      if (interactable_mushroom_room_objects[child.name]) {
        interactable_mushroom_room_objects[child.name].position = child.position
      }

      return {
        object: child,
        element: <primitive object={child} key={child.id} />,
        interactable: interactable_mushroom_room_objects[child.name],
      }
    })

    // SET MIN FILTER IN THE TEXTURES THAT REQUIRE IT
    const room_material = model.materials.room_material as THREE.MeshStandardMaterial
    room_material.map!.minFilter = THREE.LinearFilter

    setSceneChildren(processedSceneChildren)
  }, [model])

  useEffect(() => {
    const children_not_in_scene = sceneChildren
      .map((sceneChild) => sceneChild.object)
      .filter((obj) => !model.scene.children.find((child) => child.id === obj.id))

    model.scene.children.push(...children_not_in_scene)
  }, [model, sceneChildren])

  useEffect(() => {
    if (!pickedApples) {
      const apple_data = getAppleData()
      setPickedApples(apple_data)
    }
  }, [pickedApples, setPickedApples])

  useEffect(() => {
    localStorage.setItem('apples', JSON.stringify(pickedApples))
  }, [pickedApples])

  useEffect(() => {
    if (!currentInteractionObj) return

    const { currentInteraction, currentlyInspecting } = currentInteractionObj

    // Pull apple from under the bed
    if (
      currentInteraction.id === 'not_picked_apple' &&
      currentlyInspecting.id === 'bed' &&
      bed_apple_ref.current
    ) {
      bed_apple_ref.current.applyImpulse({ x: 0.5, y: 0, z: 0 }, true)

      setTimeout(() => {
        pulled_apple.current = true
      }, 1500)
    }
  }, [currentInteractionObj])

  // DISPOSE OBJECTS ON UNMOUNT
  useEffect(() => {
    return () => {
      if (!floorLoaded || !sceneChildren.length) return
      sceneChildren.forEach((child) => deepDispose(child.object))
    }
  }, [sceneChildren, floorLoaded])

  const getInteractionSensor = (child: SceneChild) => {
    if (!child.interactable) return

    const sensor_offset = new THREE.Vector3().copy(child.interactable.sensor_offset)
    sensor_offset.applyQuaternion(child.object.quaternion)

    // After many attemps, it wasn't possible to use bbox.max.z here.
    const position = new THREE.Vector3(child.object.position.x, 1.5, child.object.position.z).add(
      sensor_offset
    )

    const addInteractableObject = (e: CollisionPayload) => {
      if (!child.interactable || e.colliderObject?.name !== 'bianca') return
      setInteractableObject(child.interactable)
    }

    const removeInteractableObject = (e: CollisionPayload) => {
      if (e.colliderObject?.name !== 'bianca') return
      setInteractableObject(null)
    }

    return (
      <CuboidCollider
        position={position}
        sensor
        args={child.interactable.sensor_size}
        onIntersectionEnter={addInteractableObject}
        onIntersectionExit={removeInteractableObject}
        rotation={child.object.rotation}
      />
    )
  }

  const renderApple = () => {
    const bed_apple = sceneChildren.find((child) => child.object.name.includes('apple'))
    if (!bed_apple) return

    const getSparkles = (apple_name: string, position: THREE.Vector3) => {
      if (!justPickedApples || !justPickedApples[apple_name]) return null

      return <AppleSparkles position={position} />
    }

    const pickApple = (e: CollisionPayload, apple: SceneChild) => {
      if (e.colliderObject?.name !== 'bianca' || !pickedApples || !pulled_apple.current) return
      const apple_data = getAppleData()
      const updated_apples = { ...apple_data }

      if (updated_apples.list[apple.object.name] === false) {
        updated_apples.collected += 1
        updated_apples.list[apple.object.name] = true
        setPickedApples(updated_apples)

        const updated_just_picked_apples = { ...justPickedApples }
        updated_just_picked_apples[apple.object.name] = true
        setJustPickedApples(updated_just_picked_apples)

        // Since the apple under the bed is dynamic, we need to save the position before picking it,
        // because it'll disappear the moment we pick it, so it won't be accessible in the update
        if (bed_apple_ref.current) {
          const { x, y, z } = bed_apple_ref.current.worldCom()
          last_bed_apple_position_ref.current = new THREE.Vector3(x, y, z)
          bed_apple_ref.current = null
        }
      }
    }

    const position = last_bed_apple_position_ref.current || bed_apple.object.position

    return (
      <group key={bed_apple.object.id}>
        <>
          {pickedApples?.list[bed_apple.object.name] ? null : (
            <RigidBody
              name={bed_apple.object.name}
              ref={bed_apple_ref}
              key={bed_apple.object.id}
              type="dynamic"
              colliders="ball"
              onCollisionEnter={(e) => pickApple(e, bed_apple)}
            >
              {bed_apple.element}
            </RigidBody>
          )}
        </>

        {getSparkles(bed_apple.object.name, position)}
      </group>
    )
  }

  const renderScene = () => {
    const objects_body_type: { [key: string]: RigidBodyTypeString } = {
      office_chair: 'dynamic',
      drawing_tablet: 'dynamic',
      game_controller: 'dynamic',
      dumbbell: 'dynamic',
      arcade_stick: 'dynamic',
      carton_box: 'dynamic',
      dumbbell001: 'dynamic',
      dumbbell002: 'dynamic',
    }

    const objects_enabled_translations: { [key: string]: Boolean3Tuple } = {
      office_chair: [true, false, true],
    }

    const objects_collider_type: { [key: string]: RigidBodyAutoCollider } = {
      bed: 'trimesh',
      room_floor: 'trimesh',
      room_walls: 'trimesh',
      carton_box: 'trimesh',
      handrail: 'trimesh',
      mysterious_door: 'trimesh',
    }

    const objects_density: { [key: string]: number } = {
      carton_box: 17,
    }

    const objects_without_bodies_lax = [
      'shadows',
      'book',
      'pillow',
      'curtain',
      'window',
      'rug',
      'pacman',
      'notebook',
      'cherry_blossom',
      'flowerpot',
      'plant_trunk',
      'keyboard',
      'mouse',
      'house_monitor',
    ]
    const objects_without_bodies_specific = ['spanish_flag', 'doorknob', 'door_tunnel']

    const filteredScene = sceneChildren.filter(
      (obj) => !objects_with_custom_components.find((obj_name) => obj.object.name.includes(obj_name))
    )

    return filteredScene.map((child) => {
      if (
        objects_without_bodies_lax.find((objName) => child.object.name.toLowerCase().includes(objName)) ||
        objects_without_bodies_specific.find((objName) => child.object.name.toLowerCase() === objName)
      ) {
        return <group key={child.object.id}>{child.element}</group>
      }

      return (
        <RigidBody
          ref={child.object.name === 'room_floor' ? floor_physics_body : null}
          name={child.object.name}
          key={child.object.id}
          colliders={objects_collider_type[child.object.name] || 'cuboid'}
          restitution={0.1}
          type={objects_body_type[child.object.name] || 'fixed'}
          enabledTranslations={objects_enabled_translations[child.object.name] || [true, true, true]}
          density={objects_density[child.object.name] || 1}
        >
          {child.element}
          {getInteractionSensor(child)}
        </RigidBody>
      )
    })
  }

  const wall2_euler = new THREE.Euler(0, -0.95, 0, 'XYZ')
  const wall2_quaternion = new THREE.Quaternion().setFromEuler(wall2_euler)

  const wall3_euler = new THREE.Euler(0, 0.95, 0, 'XYZ')
  const wall3_quaternion = new THREE.Quaternion().setFromEuler(wall3_euler)

  const handrail_wall_euler = new THREE.Euler(0, -0.2, 0, 'XYZ')
  const handrail_wall_quaternion = new THREE.Quaternion().setFromEuler(handrail_wall_euler)

  const addInteractableObjectExit = (e: CollisionPayload) => {
    if (e.colliderObject?.name !== 'bianca') return
    setInteractableObject(interactable_mushroom_room_objects.house_exit)
  }

  const removeInteractableObjectExit = (e: CollisionPayload) => {
    if (e.colliderObject?.name !== 'bianca') return
    setInteractableObject(null)
  }

  return (
    <group>
      {renderScene()}
      {renderApple()}

      {/* Exit house sensor */}
      <CuboidCollider
        position={[0, 1, 15.5]}
        sensor
        args={[2.5, 1, 1]}
        onIntersectionEnter={addInteractableObjectExit}
        onIntersectionExit={removeInteractableObjectExit}
      />

      {/* Invisible wall covering the stairs handrails */}
      <CuboidCollider args={[0.4, 2.5, 3]} position={[8.7, 3, 1.5]} quaternion={handrail_wall_quaternion} />

      {/* Invisible walls surrounding the room */}
      <CuboidCollider args={[8, 15, 0.5]} position={[0, 1.5, 16]} />
      <CuboidCollider args={[8, 15, 0.5]} position={[-10, 1.5, 12]} quaternion={wall2_quaternion} />
      <CuboidCollider args={[8, 15, 0.5]} position={[10, 1.5, 12]} quaternion={wall3_quaternion} />

      {/* Lights */}
      <pointLight
        // ref={pointLightRef}
        color={'#cbad25'}
        castShadow={false}
        position={[6, 6.5, -1]}
        intensity={25}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />

      <directionalLight
        color={'#ffffff'}
        castShadow={false}
        position={[-7, 10, 10]}
        intensity={1.3}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />

      <Environment
        background
        resolution={512}
        files={[ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG]}
      />
    </group>
  )
}

export default MushroomHouseInterior

useGLTF.preload('/models/portfolio_forest/mushroom_house_interior2_draco.glb')
